// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_1tXL0","itemHead":"index_itemHead_2j8TC","itemPic":"index_itemPic_h_7sJ"};